import React, { useContext } from 'react'

import Card from '@mui/material/Card'
import Grid from '@mui/material/Grid'

// Material Dashboard 2 PRO React TS components
import MDBox from 'components/MDBox'
import MDInput from 'components/MDInput'
import MDTypography from 'components/MDTypography'
import { SeverityTimeline } from 'context/materialUI/types'

import { FormContext } from '../../constants'

function SeverityTimelineComponent() {
	const formContext = useContext(FormContext)
	const { localForm, setLocalForm, setFormEdited } = formContext
	const severityTimelines = localForm?.severityTimelines

	const handleFormUpdate = (value: SeverityTimeline[]) => {
		setLocalForm(prev => ({
			...prev,
			severityTimelines: value,
		}))
		setFormEdited(true)
	}

	return (
		<Card id="severity-timeline">
			<MDBox p={2}>
				<Grid container spacing={3} alignItems="center">
					<Grid item xs={12}>
						<MDBox display={'flex'} flexDirection={'column'} gap={2}>
							<MDTypography variant="h5" fontWeight="medium">
								Severity Timeline
							</MDTypography>
							<MDTypography variant="button" fontWeight="regular" color="text">
								<i>
									Please detail the different severity timelines that you would like to track. This
									will be used to create the severity timelines for the feedback.
								</i>
							</MDTypography>
						</MDBox>
					</Grid>
					<Grid item xs={12}>
						{severityTimelines?.map((item, index) => {
							return (
								<MDBox
									key={index}
									display={'flex'}
									flexDirection={'row'}
									gap={4}
									alignItems={'center'}
									my={2}
								>
									<MDInput
										variant="outlined"
										size="medium"
										label="Severity"
										value={item.severity}
										editable={'false'}
										InputLabelProps={{ shrink: true }}
									/>
									<MDBox display={'flex'} flexDirection={'row'} gap={2} alignItems={'center'}>
										<MDInput
											value={item.timeline}
											variant="outlined"
											size="medium"
											label="Resolution Timeline"
											autoComplete="off"
											InputLabelProps={{ shrink: true }}
											onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
												const newTimeline = Number(e.target.value)
												if (isNaN(newTimeline)) {
													// Handle invalid input here
													console.error('Invalid timeline value')
													return // or optionally show an error state to the user
												}
												const updatedTimelines = severityTimelines.map((entry, i) =>
													i === index ? { ...entry, timeline: newTimeline } : entry
												)

												handleFormUpdate(updatedTimelines)
											}}
										/>
										<MDTypography variant="button" fontWeight="regular">
											days
										</MDTypography>
									</MDBox>
								</MDBox>
							)
						})}
					</Grid>
				</Grid>
			</MDBox>
		</Card>
	)
}

export default SeverityTimelineComponent
